














import { Watch, Prop, Component, Vue } from "vue-property-decorator";
import { saveStamp } from "@/api/stamp-api";
import { Company, Office, getOurCompanies } from "@/api/company-api";
import createStampOutput from "@/api/models/factories/createStampOutput";
import StampEdit from "@/templates/StampEdit.vue";
import UploadFileSpec from "@/models/specs/UploadFileSpec";
import StampFormData from "@/api/models/StampFormData";

@Component({
  components: {
    StampEdit
  }
})
export default class OfficeStampNewPage extends Vue {
  @Prop({ required: true }) companyId!: string;

  companies: Company[] = [];

  stamp = createStampOutput();
  isEdit = false;

  company: Company | null = null;
  private office: Office | null = null;

  @Watch("companyId")
  private selectCompany() {
    const c = this.companies.find(c => String(c.companyId) === this.companyId);
    if (c) {
      this.company = { ...c };
      this.office = { ...c.office };
    } else {
      this.company = null;
      this.office = null;
    }
  }

  async ok() {
    try {
      await this.save();
      this.goListPage();
    } catch (e) {
      console.error(e);
      alert("エラーのため送信できませんでした。");
    }
  }

  cancel() {
    this.goListPage();
  }

  updateIcon(e: Event) {
    const files = (e.target as HTMLInputElement).files;
    if (!files || !files[0]) return;
    const spec = new UploadFileSpec();
    if (!spec.isSatisfied(files[0])) {
      alert(spec.errors);
      return;
    }
    const url = URL.createObjectURL(files[0]);
    this.stamp.icon = url;
    this.stamp.image = files[0];
  }

  public async created() {
    const id = this.$route.params.officeId;
    this.stamp.officeId = id;
    await this.initCompanies();
  }

  private async initCompanies() {
    this.companies = await getOurCompanies();
    this.selectCompany();
  }

  private async save() {
    if (!this.stamp) return;

    const d = StampFormData(this.stamp);
    await saveStamp(d);
  }

  private goListPage() {
    const params = { id: this.$route.params.companyId };
    this.$router.push({ name: "office-show", params });
  }
}
